import { addParamsToUrl } from '@zapier/url-utils';
import { Interval } from '@zapier/checkout/src/types';

export const buildDowngradeWarningUrl = (
  fromPlanName: string,
  toPlanName: string,
  interval: Interval,
  selectedCurrency?: string,
  accountId?: number
): string => {
  const url = encodeURI(
    `/app/billing/plans/downgrade-plan/${fromPlanName.toLocaleLowerCase()}/${toPlanName.toLocaleLowerCase()}/${interval}`
  );

  return addParamsToUrl(
    url,
    { context: accountId, currency: selectedCurrency },
    true
  );
};
